import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Carlos Avila',
    text: 'El ambiente es muy hermoso, hay bastantes mesas hay aire acondicionado para estar agusto, los baños son bonitos, tienen papel agua y jabón, es grande el lugar, tienen buena atención de parte de los empleados.'
  },
  {
    id: 2,
    name: 'Michel Berrios',
    text: 'Excelente muy espacioso y la comida deliciosa, son sushis bastante genéricos y le gustara a las personas que están comenzando a probarlo, la atención de sus gerentes y encargados es muy buena.'
  },
  {
    id: 3,
    name: 'Jhon Serrano',
    text: 'Ideal para ir con tus amigos, familia o hacer un cumpleaños, los roles son grandes para que quedes conformes, con precios accesibles y más si vas acompañado, los baños muy limpios con espejos grandes para tomar fotos y murales también.'
  }
];

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials">
      <div className="container">
        <h2 className="section-title">TESTIMONIOS DE NUESTROS CLIENTES</h2>
        <div className="testimonials-content">
          <div className="testimonial-card">
            <h3 className="testimonial-name">{testimonials[activeIndex].name}</h3>
            <p className="testimonial-text">{testimonials[activeIndex].text}</p>
          </div>
        </div>
        <div className="testimonials-dots">
          {testimonials.map((testimonial, index) => (
            <span
              key={testimonial.id}
              className={`dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

